export default navigator.platform === 'MacIntel';
